import React from 'react';
import ApexChart from 'react-apexcharts';

const RecruitmentFunnel = () => {
  const options = {
    chart: {
      type: 'bar',
      height: 350,
      dropShadow: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        barHeight: '80%',
        isFunnel: true,
      },
    },
    colors: [
      '#313265', // New Inquiry
      '#FFC300', // Contacted
      '#DAF7A6', // Qualified
      '#33FF57', // Site Visit Scheduled
      '#33FFF0', // Site Visit Complete
      '#3357FF', // Meeting Done
      '#7D33FF', // Negotiation
      '#FF33A8', // Booked
    ], // Unique colors for each stage
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px', // Increased font size for data labels
        fontWeight: 'bold',
      },
      formatter: function (val, opt) {
        return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val;
      },
      dropShadow: {
        enabled: false,
      },
    },
    title: {
      text: 'Recruitment Funnel',
      align: 'center', // Center-aligned title
      style: {
        fontSize: '20px', // Increased font size for the title
        fontWeight: 'bold',
      },
    },
    xaxis: {
      categories: [
        'New Inquiry',
        'Contacted',
        'Qualified',
        'Site Visit Scheduled',
        'Site Visit Complete',
        'Meeting Done',
        'Negotiation',
        'Booked',
      ],
      labels: {
        style: {
          fontSize: '14px', // Increased font size for x-axis labels
        },
      },
    },
    legend: {
      show: false,
    },
  };

  const series = [
    {
      name: 'Leads',
      data: [1380, 1100, 990, 880, 740, 548, 330, 200],
    },
  ];

  return (
    <div id="chart">
      <ApexChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default RecruitmentFunnel;
